var vm = new Vue({
    el: "#YI",
    data: {
        websiteInfo: Y.websiteInfo,
        scrollTop: 0,
        menuActive: false,
        data: {
            bannerList: [],
            serviceList: [],
            newsList: [],
            partnerList: [],
        },
    },
    created: function () {
        this.menuActive = false;
        var params = Y.GetLocationParams();
        var id = params.level;
        if (id) {
            var offsetTop = document.querySelector("#" + id).offsetTop;
            window.scrollTo({
                top: offsetTop - 50,
                behavior: "smooth",
            });
        }
    },
    mounted: function () {
        var that = this;
        var mySwiper = new Swiper(".swiper-container", {
            direction: "horizontal", // 垂直切换选项
            loop: true, // 循环模式选项
            observer: true,
            //autoplay: true,
            // 如果需要分页器
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
        document.addEventListener("scroll", function () {
            //that.scrollTop = window.scrollY;
        });
        window.addEventListener("touchmove", function (event) {
            //that.scrollTop = window.scrollY;
        });
        this.getIndex();
    },
    methods: {
        goto: function (id) {
            this.menuActive = false;
            var offsetTop = document.querySelector("#" + id).offsetTop;
            window.scrollTo({
                top: offsetTop - 50,
                behavior: "smooth",
            });
        },
        getIndex: function () {
            var that = this;
            Y.Axios.get(G.Api + "/home/index").then(function (reply) {
                if (reply.code === 200) {
                    that.data = reply.data;
                    Y.Footer = reply.data.websiteInfo;
                }
            });
        },
        toggleMenu: function () {
            this.menuActive = !this.menuActive;
        },
    },
});
